interface OfflineBannerProps {
  onRetry: () => void;
}

/**
 * Shown when the browser reports it is offline (real navigator connectivity
 * state, or the "بیشتر" preview toggle) — a UI state only, not a claim of
 * offline data persistence.
 */
export function OfflineBanner({ onRetry }: OfflineBannerProps) {
  return (
    <div className="offline-banner" role="alert">
      <span className="offline-banner__text">ارتباط با اینترنت قطع است</span>
      <button type="button" className="offline-banner__retry" onClick={onRetry}>
        تلاش دوباره
      </button>
    </div>
  );
}
